// extracted by mini-css-extract-plugin
export default {"bold-children":"bold-children","table-border":"table-border","subtitle-text":"subtitle-text","quantity-input":"quantity-input"};